import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _times from "lodash/times";
import _isNumber from "lodash/isNumber";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import './index.scss';
import cx from 'classnames';
import React from 'react';
import Icon from '../Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
var defaultProps = {
  extraClass: '',
  size: 18,
  wrapped: false
};

var Rating = /*#__PURE__*/function (_React$Component) {
  _inherits(Rating, _React$Component);

  var _super = _createSuper(Rating);

  function Rating(props) {
    var _this;

    _classCallCheck(this, Rating);

    _this = _super.call(this, props);
    _this.state = {
      hoveredRating: -1
    };
    return _this;
  }

  _createClass(Rating, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          extraClass = _this$props.extraClass,
          onRate = _this$props.onRate,
          rating = _this$props.rating,
          size = _this$props.size,
          wrapped = _this$props.wrapped;
      var hoveredRating = this.state.hoveredRating;
      var currentRate = rating != null && _isNumber(rating) ? rating - 1 : hoveredRating;
      return ___EmotionJSX("div", {
        className: cx('le-shared-rating', {
          'rating-wrapped': wrapped
        }, extraClass)
      }, _times(5, function (index) {
        return ___EmotionJSX("button", {
          className: cx({
            'active-rating-star': index <= currentRate
          }),
          key: index,
          onClick: function onClick() {
            return onRate(index + 1);
          },
          onMouseEnter: function onMouseEnter() {
            _this2.setState({
              hoveredRating: index
            });
          },
          onMouseLeave: function onMouseLeave() {
            _this2.setState({
              hoveredRating: -1
            });
          },
          type: "button"
        }, ___EmotionJSX(Icon, {
          name: "star",
          size: size
        }));
      }));
    }
  }]);

  return Rating;
}(React.Component);

_defineProperty(Rating, "defaultProps", defaultProps);

export default Rating;